import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function SearchIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 15} height={height || 15.968} viewBox="0 0 15 15.968">
      <path
        data-name="Path 648"
        d="M15.1 13.652h-.76l-.271-.261a6.3 6.3 0 10-.678.678l.261.271v.76l2.905 3.864L18 17.526zm-5.81 0a4.358 4.358 0 114.358-4.358 4.352 4.352 0 01-4.354 4.358z"
        transform="translate(-3 -3)"
        fill={color || "#CCCCCC"}
      />
    </svg>
  );
}
